

































































import { Component } from 'vue-property-decorator';
import AdminService from '@/api/AdminService';
import BasePagination from '@/components/BasePagination/BasePagination.vue';
import Page from '@/componentsV2/molecules/Page/Page.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import Cell from '@/components/atoms/Grid/Cell.vue';
import Container from '@/components/atoms/Grid/Container.vue';
import moment from 'moment';

@Component({
  components: {
    FilledButton,
    Cell,
    Container,
    Page
  }
})
export default class IdentifyCustomer extends BasePagination {
  adminService = new AdminService();
  loading: boolean = false;
  lastRun: string = '';

  async created() {
    this.checkScriptStatus();
  }

  async RunScript() {
    this.loading = true;
    this.lastRun = '';
    setTimeout(() => {
      setInterval(this.checkScriptStatus, 40000);
    }, 10000);
    await this.adminService.runIdentifyCustomersScript();
  }

  async checkScriptStatus() {
    const {
      data: settings
    } = await this.adminService.getIdentifyCustomersSettings();

    if (!settings || settings.status === 'ready') {
      this.loading = false;
    } else {
      this.loading = true;
    }

    this.lastRun = settings
      ? moment(settings.lastRun)
          .utc()
          .format('YYYY-MM-DD HH:mm:ss')
      : 'N/A';
  }
}
